import { useState, useEffect } from 'react';

export const useBeforeFirstRender = (f: () => unknown) => {
  const [hasRendered, setHasRendered] = useState<boolean>(false);

  useEffect(() => setHasRendered(true), [hasRendered]);

  if (!hasRendered) f();
};
